<template>
    <Skeleton class="flex flex-col">
        <div class="mb-0.5">
            <div class="skeleton-item-block h-16 w-full" />
        </div>
        <div class="flex items-center gap-0.5">
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
            <div class="skeleton-item-block h-12 w-full" />
        </div>
        <div class="grid gap-2 py-6 px-3 grid-cols-4 flex-grow rounded-md">
            <div class="skeleton-item-block col-span-3 h-full w-full rounded-md min-h-40" />
            <div class="skeleton-item-block h-full w-full rounded-md min-h-40" />
            <div class="skeleton-item-block col-span-2 h-full w-full rounded-md min-h-40" />
            <div class="skeleton-item-block col-span-2 h-full w-full rounded-md min-h-40" />
        </div>
    </Skeleton>
</template>

<script setup lang="ts">
import Skeleton from '@/components/RedesignBaseComponents/Loader/Skeleton.vue'
</script>
